import { render, staticRenderFns } from "./ItemDialog.vue?vue&type=template&id=736112c1&scoped=true"
import script from "./ItemDialog.vue?vue&type=script&lang=ts"
export * from "./ItemDialog.vue?vue&type=script&lang=ts"
import style0 from "./ItemDialog.vue?vue&type=style&index=0&id=736112c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736112c1",
  null
  
)

export default component.exports